import { Provider } from '@angular/core'
import { GamePlayService } from 'game-play-services'
import { GamePlayConfig } from 'shared-services'
import { gamePlayConfigToken } from './game-play-config.token'

export const gamePlayServiceProvider: Provider = {
  provide: GamePlayService,
  useFactory: (gamePlayConfig: GamePlayConfig): GamePlayService => {
    return new GamePlayService(gamePlayConfig)
  },
  deps: [gamePlayConfigToken],
}
